const quote = ({
  project,
  clients,
}) => {

  let projectTypes = []

  if(project && project.meta.projectTypes) {
    projectTypes = project.meta.projectTypes
  }

  return [
    {
      id: 'name',
      title: 'Name',
      helperText: 'Enter the quote name',
      default: '',
      validate: {
        type: 'string',
        methods: [
          ['required', 'Required'],
        ],
      },
    },
    {
      id: 'client',
      title: 'Client',
      helperText: 'Choose the client',
      component: 'select',
      options: clients.map(client => {
        return {
          title: client.name,
          value: client.id,
        }
      }),
      default: 0,
      validate: {
        type: 'number',
        methods: [
          ['required', 'Required'],
          ['moreThan', 0, 'Must be more than zero'],
        ],
      },
    },
    {
      id: 'meta.type',
      title: 'Project Type',
      helperText: 'Choose the type of project',
      component: 'select',
      options: projectTypes.map(projectType => {
        return {
          title: projectType.name,
          value: projectType.name,
        }
      })
    },
  ]
}

export default quote